export default __webpack_public_path__ + "static/media/info.f5d7e801.png";